import React, { useRef, useState, useEffect } from "react";
import { useFrame } from "@react-three/fiber";
import { Text } from "@react-three/drei";

const getDirectionIcon = (panelSize, index, type) => {
  if (index == 0) return "⮁";
  else if (index == 1) return panelSize == 2 ? (type == 'klasik' ? "x":"↶") : "⮁";
  else if (index == 2) return panelSize == 3 ? (type == 'klasik' ? "x":"↶") : "⮁";
  else if (index == 3) return panelSize == 4 ? (type == 'klasik' ? "x":"↶") : "⮁";
};

const GuillotineGlass = ({
  isExporting,
  isOpen,
  glassWidth,
  netPanelHeight,
  frameThickness,
  topBoxHeight,
  hegiht,
  config,
  panelSize,
  almColor,
  glassColor,
  glassColor2
}) => {
  const panelRefs = useRef([]);
  const [step, setStep] = useState(0);
  const [dir, setDir] = useState(0); // 1: açılıyor, -1: kapanıyor
  const [active, setActive] = useState(false);
  const [openingFinished, setOpeningFinished] = useState(false);
  const topFlapRef = useRef(null);

  const panelGap = netPanelHeight + 4.4 * frameThickness - 0.12;
  const baseYs = Array.from({ length: panelSize }).map((_, i) =>
    hegiht / 2 - topBoxHeight - (i + 1.03) * panelGap
  );
  const speed = 0.03;

  useEffect(() => {
    if (isOpen) {
      setStep(0);
      setDir(1);
      setActive(true);
      setOpeningFinished(false); // yeniden açılıyor
    } else if (openingFinished) {
      setStep(panelSize);
      setDir(-1);
      setActive(true);
    }
  }, [isOpen]);

  useFrame(() => {
    if (!active) return;

    const lastIndex = panelSize - 1;

    if (dir === 1) { // açılma işlevi
      const targetY = baseYs[lastIndex];

      if (step === 0) {
        // Tüm camları birlikte indir
        let done = true;
        for (let i = 0; i <= lastIndex; i++) {
          const mesh = panelRefs.current[i];
          mesh.position.y += (targetY - mesh.position.y) * speed;
          if (Math.abs(mesh.position.y - targetY) > speed / 5) done = false;
        }
        if (done) {
          topFlapRef.current.rotation.x += ((-Math.PI / 8) - topFlapRef.current.rotation.x) * speed;
          setTimeout(() => setStep(1), 200);
        }
      }

      else if (step === 1) {
        // En alttaki cam açılır
        if (config.sub_category != "klasik") {
          const mesh = panelRefs.current[lastIndex];
          mesh.rotation.x += ((Math.PI / 6) - mesh.rotation.x) * speed;
          if (Math.abs(mesh.rotation.x - Math.PI / 6) < speed) {

            if (panelSize > 2) {
              const mesh2 = panelRefs.current[lastIndex - 1];
              mesh2.rotation.x += ((Math.PI / 12) - mesh2.rotation.x) * speed;
              if (Math.abs(mesh2.rotation.x - Math.PI / 12) < speed) {
                setStep(panelSize); // açılma tamam
                setActive(false);
                setOpeningFinished(true); // ✅ açılma bitti
              }
            } else {
              setStep(panelSize); // açılma tamam
              setActive(false);
              setOpeningFinished(true); // ✅ açılma bitti
            }
          }
        } else {
          setStep(panelSize);
          setActive(false);
          setOpeningFinished(true);
        }
      }
    }

    if (dir === -1) {
      if (step === panelSize) {
        if (config.sub_category != "klasik") {
          if (panelSize > 2) {
            const mesh = panelRefs.current[lastIndex - 1];
            mesh.rotation.x += (0 - mesh.rotation.x) * speed;
            if (Math.abs(mesh.rotation.x) < speed / 5) {
              // En alttaki cam kapanıyor
              const mesh = panelRefs.current[lastIndex];
              mesh.rotation.x += (0 - mesh.rotation.x) * speed;
              if (Math.abs(mesh.rotation.x) < speed / 5) {
                topFlapRef.current.rotation.x += (0 - topFlapRef.current.rotation.x) * speed;
                setTimeout(() => setStep(step - 1), 100);
              }
            }
          } else {
            // En alttaki cam kapanıyor
            const mesh = panelRefs.current[lastIndex];
            mesh.rotation.x += (0 - mesh.rotation.x) * speed;
            if (Math.abs(mesh.rotation.x) < speed / 5) {
              topFlapRef.current.rotation.x += (0 - topFlapRef.current.rotation.x) * speed;
              setTimeout(() => setStep(step - 1), 100);
            }
          }
        } else {
          topFlapRef.current.rotation.x += (0 - topFlapRef.current.rotation.x) * speed;
          setTimeout(() => setStep(step - 1), 100);
        }
      } else if (step > 0 && step < panelSize) {
        // step = 2 → cam[0..2] cam[step]'in hizasına çıkar
        const targetY = baseYs[step];
        let done = true;
        for (let i = 0; i <= step; i++) {
          const mesh = panelRefs.current[i];
          const diff = targetY - mesh.position.y;
          mesh.position.y += diff * speed;
          if (Math.abs(diff) > speed) done = false;
        }
        if (done) {
          topFlapRef.current.rotation.x += (0 - topFlapRef.current.rotation.x) * speed;
          setTimeout(() => setStep(step - 1), 100);
        }
      } else if (step === 0) {
        // cam[0] en yukarıya çıkıyor
        const mesh = panelRefs.current[0];
        const targetY = baseYs[0];
        const diff = targetY - mesh.position.y;
        mesh.position.y += diff * speed;
        if (Math.abs(diff) < speed / 5) {
          setActive(false);
        }
      }
    }

  });


  return (
    <>
      {Array.from({ length: panelSize }).map((_, index) => {
        const width = glassWidth - 0.005;
        const height = netPanelHeight + 0.035;
        const thickness = frameThickness;
        const zOffset = 0.03 * (index - 1);

        return (
          <group
            key={index}
            ref={(ref) => (panelRefs.current[index] = ref)}
            position={[0, baseYs[index], zOffset]}
          >
            {/* Çerçeve ve cam */}
            <mesh position={[-width / 2 + thickness / 2, height / 2, 0]}>
              <boxGeometry args={[thickness, height, 0.03]} />
              <meshStandardMaterial color={almColor} />
            </mesh>
            <mesh position={[width / 2 - thickness / 2, height / 2, 0]}>
              <boxGeometry args={[thickness, height, 0.03]} />
              <meshStandardMaterial color={almColor} />
            </mesh>
            <mesh position={[0, height - thickness / 2, 0]}>
              <boxGeometry args={[width, thickness, 0.03]} />
              <meshStandardMaterial color={almColor} />
            </mesh>
            {index === 0 && (
              <group ref={topFlapRef} rotation={[0, 0, 0]} position={[0, height, 0.03]}>
                <mesh>
                  <boxGeometry args={[width, thickness / 2, 0.1]} />
                  <meshStandardMaterial color={almColor} />
                </mesh>
              </group>
            )}
            {index === panelSize - 1 && (
              <mesh position={[0, height - 0.015, 0.02]} rotation={[0, 0, Math.PI / 2]}>
                <boxGeometry args={[0.02, 0.12, 0.02]} />
                <meshStandardMaterial color={"black"} />
              </mesh>
            )}
            <mesh position={[0, thickness / 2, 0]}>
              <boxGeometry args={[width, thickness, 0.03]} />
              <meshStandardMaterial color={almColor} />
            </mesh>
            {/* Cam (tek veya çift katlı) */}
            {!config.isDouble ? (
              // Tek cam
              <mesh position={[0, height / 2, -0.001]}>
                <boxGeometry args={[width - thickness * 2, height - thickness * 2, 0.005]} />
                <meshStandardMaterial color={glassColor} transparent opacity={0.5} />
              </mesh>
            ) : (
              // Isıcam (çift cam)
              <>
                <mesh position={[0, height / 2, -0.008]}>
                  <boxGeometry args={[width - thickness * 2, height - thickness * 2, 0.005]} />
                  <meshStandardMaterial color={glassColor2} transparent opacity={0.5} />
                </mesh>
                <mesh position={[0, height / 2, 0.008]}>
                  <boxGeometry args={[width - thickness * 2, height - thickness * 2, 0.005]} />
                  <meshStandardMaterial color={glassColor} transparent opacity={0.5} />
                </mesh>
              </>
            )}

            {!isExporting && (<Text
              position={[width / 2 - 0.2, height / 2, 0.02]}
              fontSize={0.2}
              color="white"
              anchorX="center"
              anchorY="middle"
            >
              {getDirectionIcon(panelSize, index, config.sub_category)}
            </Text>)}
            {!isExporting && (<Text
              position={[-width / 2 + 0.2, height / 2, 0.02]}
              fontSize={0.15}
              color="white"
              anchorX="center"
              anchorY="middle"
            >
              {index + 1}
            </Text>)}
          </group>
        );
      })}
    </>
  );
};

export default GuillotineGlass;